<template>
  <full-screen-loader v-if="loading" :white-bg="true"/>
  <smd-one-col-layout v-else
                      class="records"
                      content-styles="reset-mp">
    <smd-header class="root-files__header top-bar-box-shadow" slot="header">
      <img alt="nowserving logo"
           class="crisp-image"
           src="@/assets/images/nowserving.png"
           slot="left-actions"
           v-if="$isMobile"
           width="123px">
      <smd-fixed-tab-panel slot="left-actions"
                           v-if="!$isMobile"
                           :options="$options.tabs"/>
      <smd-btn class="icon-btn"
               icon="ns-icon-settings"
               slot="right-actions"
               @click="goToSettings">
      </smd-btn>
    </smd-header>
    <smd-fixed-tab-panel slot="toolbar"
                         v-if="$isMobile"
                         :options="$options.tabs"/>

    <div class="page-content">
      <!--      <empty-state v-if="!files.length"-->
      <!--                   :type="'records'"/>-->
      <!--      <template v-if="files.length">-->
      <!--        <list-item-file v-for="file in sortedFiles"-->
      <!--                        :key="file.uploadid"-->
      <!--                        :file-data="file"-->
      <!--                        @click.native="fetchFileURL(file.token, file.uploadid)"/>-->
      <!--      </template>-->
      <router-view/>
    </div>

  </smd-one-col-layout>

</template>

<script>
  import HeaderFunctionMixin from '@/mixins/header-functions-mixin'
  import Routes from "@/router/routes";
  import {FilesService} from '@/services/files';
  import {EducationService} from '@/services/education';
  import {transformReceivedLabResult} from '@/utils/lab-tests';
  import {PageTypes} from '@/reference';
  import {mapActions, mapGetters} from 'vuex';
  import {
    ACTION_SET_FILES_STATE,
    GETTER_DOCTOR_PATIENT_PARTNER,
    GETTER_FILES_FETCHING,
    GETTER_FILES_STATE,
    GETTER_TOKENS,
  } from '@/store/types';

  export default {
    name: 'root-files',
    mixins: [HeaderFunctionMixin],
    computed: {
      ...mapGetters({
        getDoctorPatientPair: GETTER_DOCTOR_PATIENT_PARTNER,
        filesState: GETTER_FILES_STATE,
        isFilesFetching: GETTER_FILES_FETCHING,
        tokens: GETTER_TOKENS,
      }),
      loading() {
        return this.filesState.fetching;
      },
    },
    mounted() {
      if (!this.filesState.initialized) {
        this.fetchFiles();
      }
    },
    methods: {
      ...mapActions({
        setFilesState: ACTION_SET_FILES_STATE,
      }),
      async fetchFiles() {
        this.error = null;
        this.setFilesState({fetching: true});

        try {
          const requests = this.tokens.map(({accesstoken}) => FilesService.getFiles(accesstoken));
          const responses = await Promise.all(requests);

          const {data: labResultsData} = await FilesService.getLabResults();
          const {data: pxMaterialsData} = await EducationService.getPxMaterials();

          const files = [];

          responses.forEach((response, index) => {
            const {accesstoken} = this.tokens[index];

            response.data.forEach((item) => {
              item.token = accesstoken;
              item.doctorname = this.getDoctorPatientPair[accesstoken].doctor._fullName;
              item.patientname = this.getDoctorPatientPair[accesstoken].patient.name;

              files.push(item);
            });
          });

          labResultsData.forEach((labResult) => {
            const patientTokenObj = this.tokens.find(({token}) => labResult.token === token);

            if (patientTokenObj) {
              files.push(transformReceivedLabResult(labResult, this.getDoctorPatientPair[patientTokenObj.accesstoken]));
            } else if (labResult.sourcelab) {
              files.push({...labResult, pagetype: PageTypes.__labresults});
            } else {
              files.push(labResult);
            }
          });

          const {result: pxResult, pxmaterials} = pxMaterialsData;

          if (pxResult === 1) {
            pxmaterials.forEach(material => files.push({...material, pagetype: PageTypes.educ}));
          }

          this.setFilesState({
            fetching: false,
            files,
            initialized: true,
          });
        } catch (error) {
          this.error = 'Failed to fetch your files. Please try refreshing the page.';
        }
      },
    },
    recordsHeaderLeft: {
      label: 'Records',
      route: '',
    },
    tabs: [
      {
        name: 'All Files',
        route: Routes.FILES_ALL_FILES_ROUTE,
        to: {
          name: Routes.FILES_ALL_FILES_ROUTE
        }
      },
      {
        name: 'Prescriptions',
        route: Routes.FILES_PRESCRIPTIONS_ROUTE,
        to: {
          name: Routes.FILES_PRESCRIPTIONS_ROUTE
        }
      },
      {
        name: 'Lab Tests',
        route: Routes.FILES_LABTESTS_ROUTE,
        to: {
          name: Routes.FILES_LABTESTS_ROUTE
        }
      },
      {
        name: 'Other Notes',
        route: Routes.FILES_OTHER_NOTES_ROUTE,
        to: {
          name: Routes.FILES_OTHER_NOTES_ROUTE
        }
      },
    ],
  }
</script>


<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .root-files__header {
    @include responsive(tablet, "ipad") {
      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
    @include responsive(desktop) {

      .smd-fixed-tab-panel {
        border: none;
        margin-bottom: -14px;
      }

      .smd-fixed-tab-panel__item.selected:after {
        bottom: -4px;
      }
    }
  }
</style>
